import { useCallback } from 'react'
import { AlmanacFileIndexItem } from 'hooks/queries/files/types'
import { optimisticUpdateFileInInfiniteLists } from 'hooks/queries/files/cacheUtils'
import { useQueryClient } from 'react-query'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

export const useSyncFilePreviewImage = () => {
  const queryClient = useQueryClient()
  const workspaceId = useCurrentWorkspaceId()

  const syncFilePreviewImage = useCallback(
    (file: AlmanacFileIndexItem) => {
      optimisticUpdateFileInInfiniteLists(queryClient, workspaceId, file.key, (f) => ({
        ...f,
        image_url: file.image_url,
        design_content: file.design_content,
        content: file.content,
        image_url_generating: false,
      }))
    },
    [queryClient, workspaceId],
  )

  return { syncFilePreviewImage }
}
